import React from "react"
import Seo from "./seo"

export const SeoMetaPage = ({datas}) => {
  let seoDatas = datas.edges[0].node.seo
  const schema = seoDatas.schema.raw
  return (
    <>
      <Seo
        title={seoDatas.title}
        description={seoDatas.metaDesc}
        image={seoDatas.opengraphImage?seoDatas.opengraphImage.mediaItemUrl:''}
        canonical={seoDatas.canonical}
        modifiedTime={seoDatas.opengraphModifiedTime}
        type='product'
      />
      <script type="application/ld+json">{schema}</script>
    </>
  )
  
}